export default __webpack_public_path__ + "static/media/ratemy4.db62f68b.png";